"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPlaceholder = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var avatars_1 = require("components/Avatar/avatars");
var NotFoundPlaceholder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-messages', className: 'no-data' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)(props.translations.title)),
    React.createElement("span", null, (0, translation_1.getLocalization)(props.translations.description)),
    React.createElement("span", null, (0, translation_1.getLocalization)(props.translations.help)))); };
exports.NotFoundPlaceholder = NotFoundPlaceholder;
